export const menu = [
  { key: 'home', children: [] },
  { key: 'industrySolutions', children: [{ key: 'shippingIndustrySolution' }, { key: 'deliveryIndustrySolution' }, { key: 'policeIndustrySolution' },
    { key: 'parkIndustrySolution' }] },
  { key: 'productSolutions', children: [{ key: 'electricalBike' }, { key: 'electricalMoto' }, { key: 'electricalThreeWheel' },
    { key: 'electricalFourWheel' }, { key: 'agv' }] },
  { key: 'techAdvantages', children: [{ key: 'techIot' }, { key: 'techSFC' }, { key: 'techBatteryPack' }] },
  { key: 'aboutUs', children: [{ key: 'companyProfile' }, { key: 'news' }, { key: 'honor' }] },
  { key: 'shunDianCloud', children: [] },
  { key: 'agent', children: [] }
  // { key: 'contactUs', children: [{ key: 'talentRecruitment' }, { key: 'channelCooperation' }, { key: 'bidAnnouncement' }] }
]
